import React, { useEffect } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import IntroductionCSR from "./Tabs/IntroductionCSR";
import EducationCSR from "./Tabs/EducationCSR";
import RuralInfraCSR from "./Tabs/RuralInfraCSR";
import PhotoGalleryCSR from "./Tabs/PhotoGalleryCSR";
import VideoGalleryCSR from "./Tabs/VideoGalleryCSR";
import SwachhBharatCSR from "./Tabs/SwachhBharatCSR";
import EdpCSR from "./Tabs/EdpCSR";
import MedicalCSR from "./Tabs/MedicalCSR";
import { useDispatch, useSelector } from "react-redux";
import { setCsrActiveTab } from "../../redux/slice/sliceHome";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const CsrActivitiesPageNew = () => {
  const { getText } = useLanguageTranslation();
  const { csrActiveTab } = useSelector((state) => state.homeSlice);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  useEffect(() => {
    window.scroll({ top: 0, behavior: "smooth" });
  }, [csrActiveTab]);

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Sustainable Development", "सतत विकास")}
        titleLink="/sustainable-development/csr"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            {/* <PageLastUpdated lastUpdatedOn={lastUpdated} /> */}
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "introduction" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("introduction"));
                        }}
                      >
                        {getText("Introduction", "परिचय")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "education" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("education"));
                        }}
                      >
                        {getText("Education", "शिक्षा")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "medical" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("medical"));
                        }}
                      >
                        {getText(
                          "Medical, Health Care And Sanitation",
                          "चिकित्सा, स्वास्थ्य देखभाल और स्वच्छता"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "edp" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("edp"));
                        }}
                      >
                        {getText(
                          "Entrepreneurship Development Program - EDP",
                          "उद्यमिता विकास कार्यक्रम - EDP"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "infrastructure" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("infrastructure"));
                        }}
                      >
                        {getText("Rural Infrastructure", "ग्रामीण अवसंरचना")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "swachh" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("swachh"));
                        }}
                      >
                        {getText(
                          "Swachh Bharat And Swachh Vidyalaya Abhiyan",
                          "स्वच्छ भारत और स्वच्छ विद्यालय अभियान"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "photoGallery" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("photoGallery"));
                        }}
                      >
                        {getText("Photo Gallery", "फोटो गैलरी")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          csrActiveTab === "videoGallery" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCsrActiveTab("videoGallery"));
                        }}
                      >
                        {getText("Video Gallery", "वीडियो गैलरी")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                {csrActiveTab === "introduction" && <IntroductionCSR />}
                {csrActiveTab === "education" && <EducationCSR />}
                {csrActiveTab === "infrastructure" && <RuralInfraCSR />}
                {csrActiveTab === "photoGallery" && <PhotoGalleryCSR />}
                {csrActiveTab === "videoGallery" && <VideoGalleryCSR />}
                {csrActiveTab === "swachh" && <SwachhBharatCSR />}
                {csrActiveTab === "edp" && <EdpCSR />}
                {csrActiveTab === "medical" && <MedicalCSR />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CsrActivitiesPageNew;
